import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ChallengeTrackerMilestone from '../SubComponents/ChallengeTrackerMilestone';
import CompanyChallengeBanner from '../SubComponents/CompanyChallengeBanner';
import { Forward } from '../../../common/CustomIcons';
import useCompany from '../../../hooks/useCompany';

function ChallengeTrackerV2(props) {
    const navigate = useNavigate();
    const { account } = props.User;
    const { daysLeft, daysToGo } = useCompany({ user: account?.user });
    const company = account?.user?.company;

    const [list, setList] = useState(null);
    const { challenges } = props.Challenge;

    useEffect(() => {

        let type = "";
        let temp = challenges?.map(cha => {

            if (cha.status == 1 && new Date(cha.enddate) >= new Date()) {
                type = "active";
            } else if (cha.status == 2) {
                type = "completed";
            }

            return {
                ...cha,
                statusType2: type
            }
        })

        setList(temp);
    }, [challenges]);

    let sList = list?.filter(l => l.status != 0);
    let companyChallenge = list?.filter(l => l.company == company);
    if (((company && daysLeft > 0 && companyChallenge?.length > 0 && companyChallenge[0]?.status == 0) || (company && daysToGo > 0))) {
        sList = sList?.filter(l => l.company == null);
    }

    return (
        <div id="activity-tracker" className='atct-v2 challenge-tracker'>
            <div id="cc-milestone-wrapper">
                <h5 className='section-header'>CHALLENGES</h5>

                <div id="challenge-tracker-milestone-list">
                    {
                        ((company && daysLeft > 0 && companyChallenge?.length > 0 && companyChallenge[0]?.status == 0) || (company && daysToGo > 0)) && <CompanyChallengeBanner />
                    }

                    {
                        (sList && sList?.length > 0)
                            ? sList?.map((challenge, i) => {
                                return (
                                    <ChallengeTrackerMilestone challenge={challenge} onClick={() => {
                                        navigate(`/challenges?challenge=${challenge.id}`, { state: { challengeProp: challenge } })
                                    }} />
                                )
                            }) : <div>
                                <div className='at-v2-card empty-state' onClick={() => {
                                    navigate("/challenges")
                                }}>
                                    <div className="activity-card-details">
                                        <h5>UP FOR THE CHALLENGE?</h5>
                                        <h6>Choose from our specialized challenges to have fun and keep moving.</h6>
                                    </div>
                                    <div className="acd-icon">
                                        <Forward />
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Challenge: state.Challenge,
});

export default connect(mapStateToProps, {
})(ChallengeTrackerV2);